// extracted by css-extract-rspack-plugin
export default {"quickActionButton":"src-shared-components-QuickActionButton-QuickActionButton-module__quickActionButton-Cpj43y"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"quickActionButton\":\"src-shared-components-QuickActionButton-QuickActionButton-module__quickActionButton-Cpj43y\"}";
        // 1793875573031
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  